import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnvironmentHelper {
  public API_BASE_URL: string;
  public APP_BASE_URL: string;
  environment = environment.environment;

  constructor() {
    this.API_BASE_URL = environment.API_BASE_URL;
    this.APP_BASE_URL = environment.APP_BASE_URL;
  }

  public get apiBaseUrl(): string {
    const result =
      this.API_BASE_URL + (this.API_BASE_URL.endsWith("/") ? "" : "/");

    return result;
  }

  /**
   * Where the app can be opened in a browser, for links that are copied and
   * shared (#182). In a browser that is where this page came from: right on
   * smoke3, acceptance and production alike, where APP_BASE_URL pointed the
   * develop build at the API server, which answers 404. The app on a phone
   * runs from localhost, which means nothing to anyone else, so there it is
   * APP_BASE_URL.
   */
  public get appBaseUrl(): string {
    const base = (window as any).cordova ? this.APP_BASE_URL : document.baseURI;

    return base + (base.endsWith("/") ? "" : "/");
  }
}
